var exports = {
  "zr": "x93eb46d8--75eb55--root",
  "jD": "x93eb46d8--75eb55--breadcrumbs",
  "R_": "x93eb46d8--75eb55--heading",
  "di": "x93eb46d8--75eb55--sort",
};

module.exports = exports;
